/**
 * Comments API.
 */

import { apiFetch } from './fetch';
import { API } from '../constants';
import type { Comment } from '../types/dvms.types';

export async function listComments(): Promise<Comment[]> {
    return apiFetch<Comment[]>(API.COMMENTS);
}

export async function createComment(payload: Comment): Promise<Comment> {
    return apiFetch<Comment>(API.COMMENTS, {
        method: 'POST',
        body: JSON.stringify(payload),
    });
}

export async function deleteComment(id: string): Promise<void> {
    await apiFetch(`${API.COMMENTS}/${id}`, { method: 'DELETE' });
}
